$().ready(function() {

	var $ff = $('#freeform_send_us_an_email');
	var $ffDiv = $('.form-group.send_us_an_email');
	if ($ff.length){
		$ffDiv.attr('aria-hidden', 'true');
		$ff.find('option').attr('value', 'yes');
	}

	$('#menu-expand a').on('click', function(e){
		$('header nav').toggle();
		$('body').toggleClass('nav-expanded');
		window.scrollTo(0,0);
		e.preventDefault();
	})

	var $research = $('.home-research:first');
	if ($research.length){
		$.get('/investor-relations/asx-announcements', function(data, textStatus, jqXHR){
			if (textStatus != 'success') return;
			var $data = $(data);
			var $a = $data.find('.page-downloads:first > li > a[href*=".pdf"]:lt(4)');
			var $div = $('<div class="home-research-item"><p class="date"></p><h3></h3><p><a href="" class="arrow download" target="_blank">Download</a></p></div>');
			$a.each(function(){
				var $me = $(this);
				var $item = $div.clone();
				var text = $me.text();
				var dash = text.indexOf('-');
				var date = text.substring(0, dash);
				var title = text.substring(dash+1, text.length);
				$item.find('.date').text(date);
				$item.find('h3').text(title);
				$item.find('a').attr('href', $me.attr('href'));
				$research.append($item);
			});
			$research.children('p').appendTo($research);
		});
	}

	// shorten nav on scroll
	$(window).on("scroll touchmove", function () {
	  $('body').toggleClass('shortnav', $(document).scrollTop() > 100);
	});


	// Filtering years on the ASX page
	var arrYears = [], year;

	$('.page-downloads li').each(function(){

			year = $(this).data('year');

			if ( jQuery.inArray( year, arrYears ) < 0 && year !== '' ){
                arrYears.push(year);
			}
	})

	//Sorting the array
	arrYears.sort().reverse();

	var year;

    for ( var i = 0; i < arrYears.length; ++i ) {

        var currentYear = arrYears[i].replace(/ /g,'');

        if (  currentYear !== '' ) {

        	$('.page-downloads li').each(function () {

                year = $(this).data('year').replace(/ /g,'');

                if (currentYear === year) {

                   $(this).removeClass('hide');

				} else {

					$(this).addClass('hide');

				}
            });

		} else {

			$('.page-downloads li').each(function () {

				$(this).removeClass('hide');

			});

        }

    	var pageDownloads = $('.page-downloads').clone().html();
        $('.panel-accordion').append($('<div class="panel-item"><a class="panel-item-header">FY'+ arrYears[i].substr(arrYears[i].length - 4)  + '</a><ul class="panel-item-content"> <ul class="page-downloads-cloned"> ' + pageDownloads + '</ul></div></div>'));

    }

    $('.panel-item-header').on('click', function(e){

    	e.preventDefault();
    	$(this).toggleClass('open');
    	$(this).parent().find('.panel-item-content').slideToggle();

	})

	/*----- OPEN
	if (!Cookies.get('newsletter')) {
		setTimeout(function () {
			$('[data-popup="popup-1"]').fadeIn(350);
		}, 2000);
	}
	------*/

	//----- CLOSE
	$('[data-popup-close]').on('click', function (e) {
		e.preventDefault();

		var targeted_popup_class = $(this).attr('data-popup-close');
		$('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);

		Cookies.set('newsletter', 'true', { expires: 28 });
	});

	// Scroll to team member
    $(window).load(function() {
    	var headerHeight = 100;
        var hash = window.location.hash;
        hash = hash.replace('#','');

		if ( hash !== '') {
            $('html, body').animate({
                scrollTop: $("#" + hash).offset().top - headerHeight
            }, 500);
        }
    })


	// sticky news filter bar
	$(window).on('scroll resize', function (e) {
		var bannerHeight = $('#banner').outerHeight(),
				headerHeight = $('header').outerHeight(),
				filterNavHeight = $('.filter').outerHeight();

		if ($(document).scrollTop() > (bannerHeight - headerHeight)) {
			$('.filter').addClass('fixed').css({'top': headerHeight + 'px'});
			$('body').css({'margin-top': filterNavHeight + 'px'});
		} else {
			$('.filter').removeClass('fixed');
			$('body').css({'margin-top': '0'});
		}
	});


	// isotope init
	if ($('.grid').length > 0) {
		var filterValue = (window.location.hash.substr(1)) ? '.' + window.location.hash.substr(1) : '*';

		if (window.location.hash.substr(1)) {
			$('a[data-filter="' + window.location.hash.substr(1) + '"]').addClass('active');
		} else {
			$('.all').addClass('active');
		}

		iso = $('.grid').isotope({
			itemSelector: '.element-item',
			layoutMode: 'masonry',
			filter: filterValue
		});

		// run layout to fix any overlapping elements
		setTimeout(function () {
			iso.isotope('layout');
		}, 500);
	}

	// filter button clicks
	var filters = $('.filter nav li a');
	var loadMoreBtn = $('#load-more a');

	filters.on('click', function (e) {
		if ($(this).hasClass('main-filters')){
			e.preventDefault();
		}
		filters.removeClass('active');
		$(this).addClass('active');
		if (typeof iso !== 'undefined') {
			iso.isotope('remove', iso.isotope('getItemElements'));
			loadMoreBtn.data('offset', 0);
			loadMoreBtn.trigger('click');
		}
	});

	// search click for submit
	$('.search-click').on('click', function(){
		if ($('#keywords').val() !== ''){
			$('#search form').submit();
		}
	});

	// load more news entries for grid
	loadMoreBtn.on('click', function(event){
		event.preventDefault();
		var self = this;
		var offset = $(this).data('offset');
		var $cat = $('.main-filters.active');
		var cat = $cat.length ? $cat.data('id') : '';

		$.get('/news/tiles/' + offset + '/' + cat, function(data){
			if (data !== ''){
				// create new item elements
				var $items = $(data);
				var filterValue = ($cat.attr('data-filter')) ? '.' + $cat.attr('data-filter') : '*';
				// iso.isotope({filter: filterValue});

				// append items to grid
				iso.append($items).isotope('appended', $items);
				// iso.isotope({filter: filterValue});

				setTimeout(function () {
					iso.isotope('layout');
				}, 500);

				// init twitter and linkedin share buttons
				IN.parse();
				twttr.widgets.load();

				loadMoreBtn.data('offset', offset + 12);
			} 
			else {
				$(self).text('No more news');
			}
		});
	});

});
